import { VideoIcon } from 'lucide-react';

import { getSessionLabel } from '@/lib/utils';

const SESSION_LABEL = getSessionLabel();

interface EmptySessionRecordingProps {
  readonly message?: string;
}

export default function EmptySessionRecording({
  message = `Today's ${SESSION_LABEL.lowercase} recording will be uploaded here soon`,
}: EmptySessionRecordingProps) {
  return (
    <div className="relative rounded-2xl p-8 h-44 w-78 flex flex-col items-center justify-center bg-magical-moonlight-white">
      <div className="absolute border-2 border-magical-moonlight-m border-dashed inset-[-1px] pointer-events-none rounded-[17px]" />

      {/* Video icon */}
      <div className="mb-4">
        <VideoIcon className="h-8 w-8 text-gray-400" />
      </div>

      {/* Message text */}
      <p className="text-sm text-gray-500 text-center leading-relaxed max-w-xs">
        {message}
      </p>
    </div>
  );
}
